import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { LandCoverChangeChart } from '@/components/Charts/LandCoverChange';
import { GraphFact } from '@/components/Charts/types';
import { NO_RADIUS, RadiusType } from '@/components/MapOverview/components/MapRadiusContextProvider';

import { NoPlotData } from '../NoPlotData';

export const LandCoverChangeGraphTile = ({
  landCoverChange,
  radius,
}: {
  landCoverChange: PlotReportFactElement<GraphFact[]>;
  radius: RadiusType;
}) => {
  const { t } = useTranslation();

  const noChartData = !landCoverChange.value?.length;

  if (noChartData) {
    return <NoPlotData />;
  }

  const heading =
    radius === NO_RADIUS
      ? t('shared.ncaDetail.details.landCoverChange.labels.graphHeadlineNoRadius')
      : t('shared.ncaDetail.details.landCoverChange.labels.graphHeadline', {
          radius,
        });

  return (
    <Stack center data-testid='land-cover-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={heading}
          className='w-full px-6 sm:px-0'
          popover={{
            title: heading,
            body: t('shared.ncaDetail.details.landCoverChange.labels.graphHeadlineTooltip'),
          }}
        />
        <LandCoverChangeChart data={landCoverChange} data-testid='land-cover-change-chart' />
      </Stack>
    </Stack>
  );
};
